import { render, staticRenderFns } from "./deviceComm.vue?vue&type=template&id=280d68e9&scoped=true"
import script from "./deviceComm.vue?vue&type=script&lang=js"
export * from "./deviceComm.vue?vue&type=script&lang=js"
import style0 from "./deviceComm.vue?vue&type=style&index=0&id=280d68e9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280d68e9",
  null
  
)

export default component.exports